import { createSelector } from "reselect";

import { getTripSegments as getTripSegmentsHelper } from "@app/helpers/udm/segments";

import { getTripById } from "./get-trip";
import { getTripsSegments } from "../state-accessors";

export const getTripSegments = createSelector(
  [getTripsSegments, getTripById],
  (segments, trip) => {
    if (!segments || !trip) {
      return [];
    }
    return getTripSegmentsHelper(trip, segments);
  }
);
